export enum AlgoFeatureFlags {
    EnableQualifiedCandidatesFilter = 'enable-qualified-candidates-filter',
    TurnOffNovaJobSuggestions = 'TURN_OFF_NOVA_JOB_SUGGESTIONS',
    AmJobDetailsPageUiUpdate = 'am-job-details-page-ui-update',
    EnableClinicalTrackSelectionWarningMessage = 'enable-clinical-track-selection-warning-message',
    EnableEditViewActionClinicalReview = 'edit-view-action-clinical-review',
    EnableJobMatchingRefactor = 'enable-job-matching-refactor',
    EnableAdditionalUsersInQualifiedCandidatesEmail = 'enable-additional-users-in-qualified-candidates-email',
    EnableClinicalSkillsManagement = 'enable-clinical-skills-management',
    EnableClinicalChecklistsConfiguration = 'enable-clinical-checklists-configuration',
    EnableSkillsChecklistManagementCategoryAndSkillsDisplay = 'enable-skills-checklist-management-category-and-skills-display',
    EnableMatchHistoryInClinicalReviewQuickLinks = 'enable-match-history-in-clinical-review-quick-links'
}
